import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectCrossClientUsersLoading, setCrossClientResultsClientNameFilter } from '../../../../store/crossClient/crossClientResults'
import { Form } from 'react-bootstrap'
import { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

export const CrossClientNameFilter = () => {
  const dispatch = useAppDispatch()

  const usersLoading = useAppSelector(selectCrossClientUsersLoading)
  const [clientName, setClientName] = useState<string>('')

  const handleClientNameChanged = useDebouncedCallback((newName: string) => {
    console.log(newName)
    dispatch(setCrossClientResultsClientNameFilter(newName))
  }, 300)

  return (
    <div className='d-flex gap-2 align-items-center form-control zocks-px-0.75 zocks-py-0.375 w-auto'>
      <i className='bi bi-search fs-6'></i>
      <Form.Control
        className='p-0 border-0'
        type='text'
        value={clientName}
        onChange={(e) => {
          setClientName(e.currentTarget.value)
          handleClientNameChanged(e.currentTarget.value)
        }}
        placeholder='Search client'
        disabled={usersLoading}
      ></Form.Control>
    </div>
  )
}
